import {
  HANDLE_RESTORE_ROUTE,
  HANDLE_RESTORE_ROUTE_FAILED,
  HANDLE_RESTORE_ROUTE_SUCCESS,
  RESTORE_ACCOUNT_EMAIL,
  RESTORE_ACCOUNT_EMAIL_FAILED,
  RESTORE_ACCOUNT_PASSWORD,
  RESTORE_ACCOUNT_PASSWORD_FAILED,
} from '../constants/index';
import {
  RestoreAccountPasswordType,
  restoreAccountEmailSuccess,
  restoreAccountPasswordSuccess,
} from '../actions/restoreAccountActions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { ActionType } from '../actions/themeActions';
import { ParsedResponseType } from '../../types/reduxTypes';
import { RestoreAccountMetaDataType } from '../../types/stateTypes';
import authErrors from '../../constants/authErrors';
import config from '../../shared/config';
import generateAuthError from '../../services/error.parser';
const { executeUrl, tokenUrl } = config;

function* submitEmail(action: ActionType<string>) {
  try {
    const result: Response = yield call(fetch, executeUrl, {
      body: JSON.stringify({
        actionType: 'reset-credentials',
        username: action.payload,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    if (result.status !== 200) {
      const parsed: ParsedResponseType = yield call([result, 'json']);
      throw parsed;
    }
    yield put(restoreAccountEmailSuccess());
  } catch (error) {
    yield put({
      payload: { message: generateAuthError({ error, errors: authErrors, unhandledErrorMessage: 'restoreAcc error' }) },
      type: RESTORE_ACCOUNT_EMAIL_FAILED,
    });
  }
}

function* submitNewPassword(action: ActionType<RestoreAccountPasswordType>) {
  const { authSessionId, clientId, key, password, tabId } = action.payload;
  try {
    const result: Response = yield call(fetch, tokenUrl, {
      body: JSON.stringify({
        authSessionId,
        clientId,
        key,
        password,
        tabId,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    const parsed: ParsedResponseType = yield call([result, 'json']);
    if (parsed.error) throw parsed;
    yield put(restoreAccountPasswordSuccess());
  } catch (error) {
    yield put({
      payload: { message: generateAuthError({ error, errors: authErrors, unhandledErrorMessage: 'restoreAcc error' }) },
      type: RESTORE_ACCOUNT_PASSWORD_FAILED,
    });
  }
}

function* handleResetRoute(action: ActionType<string>) {
  const restoreKey = action.payload.split('key=')[1].split('&')[0];
  try {
    const result: Response = yield call(fetch, tokenUrl, {
      body: JSON.stringify({ key: restoreKey }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    const parsed: RestoreAccountMetaDataType & ParsedResponseType = yield call([result, 'json']);
    if (parsed.error) throw parsed;
    const { authSessionId, clientId, key, tabId } = parsed;
    yield put({
      payload: {
        metaData: {
          authSessionId,
          clientId,
          key,
          tabId,
        },
      },
      type: HANDLE_RESTORE_ROUTE_SUCCESS,
    });
  } catch (error) {
    yield put({
      payload: { message: generateAuthError({ error, errors: authErrors, unhandledErrorMessage: 'restoreAcc error' }) },
      type: HANDLE_RESTORE_ROUTE_FAILED,
    });
  }
}

export default function* fetchUserWatcher(): Generator {
  yield takeEvery(RESTORE_ACCOUNT_EMAIL, submitEmail);
  yield takeEvery(RESTORE_ACCOUNT_PASSWORD, submitNewPassword);
  yield takeEvery(HANDLE_RESTORE_ROUTE, handleResetRoute);
}
